export default {
  contratos: [],
  contratosNegocio: [],
  contratosRestaurante: [],
  contratosPartner: [],
  contratosDirectorio: [],
  plantillas: [],
  estadosFirma: [
    {
      text: 'generado',
      value: 'Generado sin crear la firma'
    },
    {
      text: 'ready',
      value: 'Esperando firma del cliente'
    },
    {
      text: 'signeed',
      value: 'Firmado por el cliente'
    },
    {
      text: 'expired',
      value: 'Expirado plazo'
    },
    {
      text: 'failed',
      value: 'Error en el proceso'
    },
    {
      text: 'cancelled',
      value: 'Cancelado'
    },
  ]
}